// extracted by mini-css-extract-plugin
export default {"actions":"List_actions__Qp2-2","button":"List_button__zIJJP"};